
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, helpers } from "vuelidate/lib/validators";

// vuelidate rule
const alphaNumAndDashValidator = helpers.regex(
  "alphaNumAndDot",
  /^\/[a-z\d-/]*$/i
);

export default Vue.extend({
  name: "AdminAddCategory",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      isParent: true,
    };
  },
  computed: {
    parentCategories() {
      const categories: any[] = store.state.panel.categories.filter(
        (category: any) => category.parent === null
      );

      const items: any[] = [];

      categories.forEach((category) => {
        items.push({
          title: category.title,
          value: {
            id: category["_id"],
            path: category.parentPath,
          },
        });
      });

      return items;
    },
    title: {
      get(): string {
        return store.state.admin.categoryData.title;
      },
      set(value: string): void {
        store.dispatch("admin/updateCategoryTitle", value);
      },
    },
    titleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    parent: {
      get(): any {
        return store.state.admin.categoryData.parent;
      },
      set(value: []): void {
        store.dispatch("admin/updateCategoryParent", value);
      },
    },
    parentPath: {
      get(): string {
        return store.state.admin.categoryData.parentPath;
      },
      set(value: string): void {
        store.dispatch("admin/updateCategoryParentPath", value);
      },
    },
    parentPathError(): string[] {
      const errors: string[] = [];
      if (!this.$v.parentPath?.$dirty) {
        return errors;
      }
      !this.$v.parentPath.required && errors.push("تکمیل این فیلد الزامی است");
      !this.$v.parentPath.minLength && errors.push("تکمیل این فیلد الزامی است");
      !this.$v.parentPath.alphaNumAndDashValidator &&
        errors.push(
          "آدرس باید با اسلش (/) شروع شود. کاراکتر های مجاز: حروف، اعداد و خط فاصله (-)"
        );

      return errors;
    },
    isParentValid() {
      if (this.isParent) {
        return store.state.admin.categoryData.parent === null;
      } else {
        return store.state.admin.categoryData.parent !== null;
      }
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  mounted() {
    if (this.$route.query.child === "true") this.isParent = false;
  },
  methods: {
    addCategory(): void {
      if (store.state.admin.categoryData.parent !== null) {
        store.state.admin.categoryData.parent = this.parent?.id;
      }

      store.dispatch("admin/addCategory");
    },
    backward(): void {
      router.push({ name: "admin-all-categories" });
    },
  },
  watch: {
    isParent(newVal) {
      if (newVal === true) store.state.admin.categoryData.parent = null;
    },
  },
  validations: {
    title: {
      required,
    },
    parentPath: {
      required,
      minLength: minLength(2),
      alphaNumAndDashValidator,
    },
  },
});
